import {AppSettings} from '../constants';
import Jwt from 'helper/interceptors';
import { ObjToParam, MapResponse } from '../helper/helper-api';

export const getById = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/models/${params}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const create = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI, true, {headers: [{key: 'Key', value: params.projectId}]}).post('/api/models', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const update = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI, true, {headers: [{key: 'Key', value: params.projectId}]}).put('/api/models', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const search = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {headers: [{key: 'Key', value: params.projectId}]}).get(`/api/models/search?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const searchRoomModel = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/models/search-room-model?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const remove = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).delete(`/api/models/${params}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const addRoomToModel = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).post('/api/models/add-room-to-model',params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const removeRoomOutOfModel = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).post('/api/models/remove-room-out-of-model', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getListModelByProject = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false, {headers: [{key: 'Key', value: params.projectId}]}).get(`/api/models/select-list-items/by-project?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};




// WEBPACK FOOTER //
// ./src/Model/api.js